import PropTypes from "prop-types";

import { cn } from "@helpers/general";

import { ALButtonV2 } from "@components/ALComponents";
import { ComponentType } from "@constants/ComponentType";

function CheckoutButton({
  checkoutUrl,
  isCheckoutDisabled,
  goToCheckout,
  buttonText,
  componentType,
  saleColors,
}) {
  if (isCheckoutDisabled) {
    return (
      <div className="sidecart_checkout">
        <ALButtonV2 variant="primary" size="large" fullWidth disabled>
          Secure Checkout
        </ALButtonV2>
        <p className="sidecart__message--disabled">
          You&apos;re nearly there! <span className="bold">Add another item</span> to check out.
        </p>
      </div>
    );
  }

  return (
    <ALButtonV2
      size="large"
      fullWidth
      className={cn(
        "px-[25px] mobile:px-[20px]",
        componentType === ComponentType.ANNOUNCEMENT_BAR &&
          "h-[28px] w-[120px] typo-body desktop:typo-micro font-bold py-[6px] px-0 mobile:px-[15px] shrink-0 mobile:border-0"
      )}
      onClick={(e) => {
        e.stopPropagation();
        goToCheckout(checkoutUrl);
      }}
      buttonBackgroundColor={saleColors?.checkoutButtonBgColor}
      buttonTextColor={saleColors?.checkoutButtonTextColor}
    >
      {buttonText || "Secure Checkout"}
    </ALButtonV2>
  );
}

CheckoutButton.propTypes = {
  checkoutUrl: PropTypes.string,
  isCheckoutDisabled: PropTypes.bool,
  goToCheckout: PropTypes.func,
  buttonText: PropTypes.string,
  componentType: PropTypes.string,
  saleColors: PropTypes.shape({
    checkoutButtonBgColor: PropTypes.string,
    checkoutButtonTextColor: PropTypes.string,
  }),
};

export default CheckoutButton;
